<div [ngClass]="AppConfig.theme">
  <mat-list-item>
    <img mat-list-avatar [src]="(user.$data | async)?.avatarUrl" [alt]="(user.$data | async)?.name">
    <h3 matLine>{{ (user.$data | async)?.name }}</h3>
    <p matLine>
      <span *ngIf="state">수강 승인됨</span>
      <span *ngIf="!state">수강 신청중</span>
    </p>
    <mat-slide-toggle [(ngModel)]="state" color="primary"></mat-slide-toggle>
  </mat-list-item>
</div>




// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/course-member-item/course-member-item.component.html